import {
  Button,
  Dialog,
  ListItem,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "@sellar-io/components";
import { useState } from "react";
import { usePriceTierList } from "../../../hooks/api/v2/priceTier/usePriceTierList";
import { InfiniteList } from "../../../components/infiniteLoading/InfiniteList";
import { twMerge } from "tailwind-merge";
import { getPriceListDiscountSummary } from "../../priceLists/utils/priceListDiscountSummary";

export const AssignPriceListDialog = ({
  active,
  setActive,
  loading,
  priceListId,
  onClick,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
  loading: boolean;
  priceListId: number | null;
  onClick: (id: number | null) => void;
}) => {
  const [selectedPriceListId, setSelectedPriceListId] = useState<number | null>(
    priceListId,
  );

  const onSubmit = () => {
    onClick(selectedPriceListId);
  };

  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="Assign price list"
        description="Your customer can be assigned any of the price lists you have defined"
      />
      <DialogContent className="flex min-h-75 flex-col gap-4">
        {active && (
          <Content
            selectedPriceListId={selectedPriceListId}
            setSelectedPriceListId={setSelectedPriceListId}
          />
        )}
      </DialogContent>
      <DialogCTA>
        <Button onClick={onSubmit} loading={loading}>
          Confirm
        </Button>
      </DialogCTA>
    </Dialog>
  );
};

const Content = ({
  selectedPriceListId,
  setSelectedPriceListId,
}: {
  selectedPriceListId: number | null;
  setSelectedPriceListId: (id: number | null) => void;
}) => {
  const priceListsQuery = usePriceTierList({
    includeCounts: true,
    limit: 10,
    query: [
      {
        type: "derivationTypeIncludes",
        value: ["custom", "flat", "percentage"],
        modifier: "IN",
      },
    ],
  });

  const priceLists = priceListsQuery.data?.pages.flat() ?? [];

  return (
    <InfiniteList
      query={priceListsQuery}
      className="mb-8 flex flex-col divide-y overflow-hidden rounded-lg border border-zinc-300"
    >
      {priceLists.map((priceList) => {
        const selected = priceList.id === selectedPriceListId;

        return (
          <ListItem
            key={priceList.id}
            title={priceList.name}
            subtitle={getPriceListDiscountSummary({ counts: priceList })}
            icon={selected ? "CHECK" : "TAG_MULTIPLE_OUTLINE"}
            onClick={() => {
              setSelectedPriceListId(selected ? null : priceList.id);
            }}
            className={twMerge(
              "p-4 hover:bg-zinc-50",
              selected ? "bg-zinc-50" : "",
            )}
            iconClassName={selected ? "border-zinc-800 bg-zinc-200" : ""}
          />
        );
      })}
    </InfiniteList>
  );
};
